import React from 'react';
export function VideoIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6h13v12H3V6zm15 10.477V18a2 2 0 01-2 2H3a2 2 0 01-2-2V6a2 2 0 012-2h13a2 2 0 012 2v1.523l3.286-1.314A1.25 1.25 0 0123 7.369v9.262a1.25 1.25 0 01-1.714 1.16L18 16.477zm0-2.154l3 1.2V8.477l-3 1.2v4.646z"
  }));
}